import { useState } from "react";

export function usePhotoCarousel() {
    const [isOpen, setIsOpen] = useState(false);
    const [startIndex, setStartIndex] = useState(0);
    const open = (index: number) => {
        setStartIndex(index);
        setIsOpen(true);
    };
    return { isOpen, startIndex, open, onOpenChange: setIsOpen };
}
